import { useQuery } from '@tanstack/react-query';
import { LedidiRequestError, makeRequest } from 'features/entry-form-v2/data/makeRequest';

import { CodelistRecord } from '../domain/codelistRecordSchema';

export type GetCodelistForEntryResponse =
	| {
			type: 'success';
			record: CodelistRecord;
	  }
	| {
			type: 'error';
			error: 'codelist-not-found' | 'unknown';
	  };

export const useGetCodelistForEntryQuery = (
	args: {
		entryId: string;
		projectId: string;
	},
	opts?: {
		enabled?: boolean;
	}
) => {
	const query = useQuery<GetCodelistForEntryResponse>({
		queryKey: ['codelist', args.entryId, args.projectId],
		queryFn: async () => {
			try {
				const result = await makeRequest<{
					record: CodelistRecord;
				}>({
					method: 'getCodelistRecordForEntry',
					service: 'cde',
					data: { originalEntryId: args.entryId, projectId: args.projectId }
				});

				return {
					type: 'success',
					record: result.record
				};
			} catch (error) {
				if (error instanceof LedidiRequestError) {
					if (error.errors.some(e => e.code === 'error.codelist_not_found')) {
						return {
							type: 'error',
							error: 'codelist-not-found'
						};
					}
				}

				console.error(error);

				return {
					type: 'error',
					error: 'unknown'
				};
			}
		},
		retry: false,
		...opts
	});

	return {
		...query,
		// https://github.com/TanStack/query/issues/3584#issuecomment-1256986636
		// loading is apparently true with enabled: false, which I think is a mistake, this makes it easier to use
		isLoading: query.isLoading && query.fetchStatus !== 'idle'
	};
};
